export default __webpack_public_path__ + "static/media/Brow_6_C4.d2b24a5a.svg";